import $ from 'jquery';
import manager from 'app/module46/component-manager.js';

manager.plugin('external-links-as-target-blank', (target) => {
    const mailtoRegExp = /^mailto:[^\s]*/i;

    $('a[href]', target).each((index, element) => {
        if(typeof element.href !== 'string' || element.href === '') return true; // test first, can cause an error
	    if(mailtoRegExp.test(element.href)) return true; // mailto
	    if(sameHost(element.href)) return true; // same site
        if(element.target) return true; // target already define
        element.target = '_blank';
    });

	function sameHost(href) {
		try {
			return new URL(href).hostname === window.location.hostname;
		} catch (e) {
			// new URL will fail if relative url or anchor
			return true;
		}
	}
})
